import { useMemo } from "react";
import { pickInfrastructurePlan } from "../i18n/architecturePlanSimple";
import { useI18n } from "../i18n/useI18n";
import type { UiKey } from "../i18n/ui";
import type { AudienceMode } from "../lib/audienceMode";
import type { DeploymentStackConfig } from "../lib/deploymentStack";
import type { Workload } from "../lib/types";

type Props = {
  workload: Workload;
  deploymentStack: DeploymentStackConfig;
  audienceMode: AudienceMode;
  t: (key: UiKey) => string;
};

export function InfrastructurePlanCard({
  workload,
  deploymentStack,
  audienceMode,
  t,
}: Props) {
  const { locale } = useI18n();
  const sections = useMemo(
    () => pickInfrastructurePlan(locale, workload, deploymentStack, audienceMode),
    [locale, workload, deploymentStack, audienceMode],
  );

  return (
    <div className="plan">
      <h2>{t("plan.title")}</h2>
      <p className="sub">
        {t(audienceMode === "simple" ? "plan.subtitleSimple" : "plan.subtitle")}
      </p>
      <div className="sections">
        {sections.map((sec, i) => (
          <section key={i} className="block">
            <h3>{sec.title}</h3>
            <ul>
              {sec.items.map((line, j) => (
                <li key={j}>{line}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
      <style>{`
        .plan h2 {
          font-size: 1rem;
          margin: 0 0 0.4rem;
        }
        .sub {
          margin: 0 0 1.1rem;
          font-size: 0.82rem;
          color: var(--muted);
          line-height: 1.45;
          min-height: 5.5rem;
          min-height: 5lh;
        }
        .sections {
          display: grid;
          gap: 1rem;
        }
        .block {
          padding: 0.85rem 1rem;
          background: var(--surface2);
          border: 1px solid var(--border);
          border-radius: 10px;
        }
        .block h3 {
          font-size: 0.88rem;
          font-weight: 600;
          margin: 0 0 0.5rem;
          color: var(--accent);
        }
        .block ul {
          margin: 0;
          padding-left: 1.1rem;
          font-size: 0.84rem;
          color: var(--text);
          line-height: 1.5;
        }
        .block li {
          margin: 0.35rem 0;
        }
      `}</style>
    </div>
  );
}
